import { languageResponse } from "../types/project/language";
import { abstractApiCaller } from "./apiCaller";

class SystemApi extends abstractApiCaller {

    private sessionToken: string = '';
    private sessionEmail: string = '';

    constructor(
        sessionToken: string,
        sessionEmail: string,
    ) {
        super();
        this.sessionToken = sessionToken;
        this.sessionEmail = sessionEmail;
    }

    public async getLanguageList () {
        const endpoint = 'system/getLanguageList';

        this.abortRequest();
        return await this.query<languageResponse>(endpoint, {}, this.sessionToken, this.sessionEmail);
    }

}

export { SystemApi };
